<div class="main-div"></div>
<div class="overlay" *ngIf="loading">
    <div class="center">
        <mat-spinner class="custom-spinner"></mat-spinner>
    </div>
</div>

<div class="share-wrapper">
    <mat-card class="share-card">
        <mat-card-content>
            <h1 class="share-title">Cypher Share</h1>
            <ng-container *ngIf="!redeemed">
            <p>
                Enter the email or phone for this link and the
                access code sent in a separate message.
            </p>
            <mat-radio-group [(ngModel)]="contactMethod"
                             class="radio-group">
                <mat-radio-button value="email" color="primary">
                    Email
                </mat-radio-button>
                <mat-radio-button value="phone" color="primary">
                    Phone
                </mat-radio-button>
            </mat-radio-group>
            <div class="field-wrap" *ngIf="contactMethod === 'email'">
                <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Email Address</mat-label>
                    <input matInput
                           type="email"
                           [(ngModel)]="emailAddress">
                </mat-form-field>
            </div>
            <div class="field-wrap" *ngIf="contactMethod === 'phone'">
                <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Phone Number</mat-label>
                    <input matInput
                           type="tel"
                           inputmode="tel"
                           autocomplete="tel"
                           placeholder="3035551212"
                           [(ngModel)]="phoneNumber">
                    <mat-hint>
                        10-digit US number. +1 is optional.
                    </mat-hint>
                </mat-form-field>
            </div>
            <div class="field-wrap">
                <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Access Code</mat-label>
                    <input matInput
                           type="text"
                           [(ngModel)]="accessCode">
                </mat-form-field>
            </div>
            <button mat-raised-button
                    color="primary"
                    class="full-width"
                    type="button"
                    (click)="onSubmit()">
                Open Share
            </button>
            <div class="error-message" *ngIf="errorMessage">
                {{ errorMessage }}
            </div>
            </ng-container>
            <ng-container *ngIf="redeemed">
            <p *ngIf="expireDT">Expires: {{ expireDT }}</p>
            <div *ngIf="entities.length === 0">
                No shared items were found.
            </div>
            <div class="entity"
                 *ngFor="let entity of entities">
                <h3 *ngIf="entity.entityType === noteType">
                    {{ entity.payload?.title || 'Shared Note' }}
                </h3>
                <h3 *ngIf="entity.entityType !== noteType">
                    Shared file {{ entity.entityUId }}
                </h3>
                <ng-container
                    *ngIf="displayNoteHtml(
                        $safeNavigationMigration(entity.payload?.content)) as noteHtml">
                <div class="note-body"
                     [innerHTML]="noteHtml">
                </div>
                </ng-container>
            </div>
            </ng-container>
        </mat-card-content>
    </mat-card>
</div>
